<template lang="html">
  <div>
    <div class="section-container">
      <div class="text-to-left">
        <div>
        <h2>Beautiful, intuitive interface</h2>
        <p>Including flexible screening views that you can customise, and candidate Fast Track to move candidates
          between roles during a campaign.</p>
        </div>
      </div>
      <div class="image-right image1">
        &nbsp;
      </div>
    </div>

    <div class="section-container reverse-for-small">
      <div class="image-left image2">
        &nbsp;
      </div>
      <div class="text-to-right">
      <div>
        <h2>Groundbreaking people analytics</h2>
        <p>Generate 16 unique equal opportunities reports at the click of a button. Identify discrimination – including
          positive discrimination – during a campaign, in absolute and grade-controlled terms. Compare your firm’s
          performance with the industry average.</p>
      </div>
      </div>
    </div>

    <div class="section-container">
      <div class="text-to-left">
      <div>
        <h2>Truly secure</h2>
        <p>Use sensitive personal data safely in decision-making. Our ATS has platinum-level information security with ISO27001 accreditation. No other Early talent legal ATS has this.</p>
      </div>
      </div>
      <div class="image-right" :id="animation">
        &nbsp;
      </div>
    </div>

  </div>
</template>

<script>

import Bodymovin from 'lottie-web';

export default {
  name: 'HomeProductsCandidAtsMainSection',
  props: {
  },
  components: {
  },
  data() {
    return {
      animation: 'security',
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
    Bodymovin.loadAnimation({
      container: document.getElementById(this.animation),
      path: `${window.location.origin}/static/animations/${this.animation}.json`,
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container {
}

.section-container {
  display: flex;
  min-height: 450px;
}

.text-to-left, .text-to-right {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  width: 58%;
  padding: 0 10%;
}

.text-to-left h2, .text-to-right h2 {
  font-size: 56px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
}

.text-to-left p, .text-to-right p {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin: 10px 0 50px 0;
}

.text-to-left {
  background-color: $light-grey-background;
  color: $main-text;
}

.text-to-right {
  background-color: $dark-grey-background;
  color: $white-text;
}

.image-left, .image-right {
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 42%;
  height: 450px;
}

@media only screen and (min-width: 800px) {
  .text-to-left p:last-of-type, .text-to-right p:last-of-type {
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 800px) {
  .section-container {
    flex-direction: column;
    min-height: auto;
  }

  .reverse-for-small {
    flex-direction: column-reverse !important;
  }

  .text-to-left, .text-to-right {
    width: 100%;
    padding: 0 20px;
  }

  .text-to-left h2, .text-to-right h2 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.39;
    margin: 32px 0 0 0;
  }

  .text-to-left p, .text-to-right p {
    font-size: 18px;
    line-height: 1.43;
    letter-spacing: normal;
    margin: 20px 0 40px 0;
  }

  .image-left, .image-right {
    width: 100%;
    height: 240px;
  }

}

.image1 {
  background-image: url('../../../../assets/img/candidAtsImages/image1.png');
}

.image2 {
  background-image: url('../../../../assets/img/candidAtsImages/image2.png');
}

.image3 {
  background-image: url('../../../../assets/img/candidAtsImages/image3.png');
}

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsCandidAts/components/homeProductsCandidAtsMainSection.vue